/* eslint-disable */
import { AUTH_UNLOCK_CLICKED } from '../Auth.types';

/**
 * Auth action for unlock action
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_UNLOCK_CLICKED>>} The created `Action`
 */
const authUnlock = () => ({ fromPayload }) => {
  return fromPayload(null, {}, AUTH_UNLOCK_CLICKED);
};

export default authUnlock;
